import React, {useRef, useState} from "react";

import "./FileUploadButton.css";
import {StandardButton} from "../standard-button/StandardButton";
import ReactModal from "react-modal";

export const TrainingFileUploadButton = ({context, setFile, disableButton, buttonText}) => {

    ReactModal.setAppElement('#root');

    const fileInputRef = useRef();
    const [fileSelected, setFileSelected] = useState(false);
    const [showLargeFileModal, setShowLargeFileModal] = useState(false);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    }

    const handleFileUploadChange = ({target}) => {
        const files = target.files;
        processFile(files[0]);
    }

    const processFile = (fileToBeUploaded) => {
        if (fileToBeUploaded.size > 16777216) {
            setShowLargeFileModal(true);
            setFile(null);
            setFileSelected(false);
        } else {
            setFile(null);
            const fileReader = new FileReader();
            fileReader.readAsDataURL(fileToBeUploaded);
            fileReader.onload = () => {
                const name = fileToBeUploaded.name;
                const extension = "." + name.split(".").pop();
                const size = fileToBeUploaded.size;
                const data = fileReader.result.split("base64,").pop();
                const file = {
                    name,
                    extension,
                    size,
                    data,
                    contextObjectReferenceVO: {externalReference: "1", contextId: "1"}
                };
                setFile(file);
            }
            setFileSelected(true);
        }
        if (!fileSelected) {
            setFile(null);
        }
    }

    return (
        <div>
            <div>
                <input ref={fileInputRef} className="file-upload-button-file-input" type="file"
                       onChange={handleFileUploadChange}/>
                <StandardButton text={buttonText} onClick={handleButtonClick}
                                required={(context.newTrainingSelected) ? !fileSelected : false}
                                disabled={disableButton}/>
            </div>
            <ReactModal isOpen={showLargeFileModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">File Size Warning</p>
                    <p className="file-warning-modal-text">
                        The following file is larger than 16MB and cannot be uploaded:
                    </p>
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowLargeFileModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
